import { Divider, Flex, Skeleton, Space, Text } from '@mantine/core';
import { QuestionnaireItem } from './QuestionnaireItem';
import { BmsSampleVoucherItem } from './BmsSampleVoucherItem';
import { useVoucherStateStore } from '../stores/VoucherStateStore';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { EmptyPlaceholder } from './EmptyPlaceholder';
import { MyIcon } from '@web/common-ui';
import { VoucherAllowanceStatus } from '@web/common';

export const ClosedQuestionnaires = observer(() => {
  const store = useVoucherStateStore();
  const { t } = useTranslation('questionnaire');

  const filledOutQuestionnaires = store.voucherStates?.filter(
    (item) => item.questionnaireCompleted,
  );
  const hasBmsSampleRedeemed =
    store.bmsSampleVoucherStatus?.type === VoucherAllowanceStatus.Redeemed;

  const hasItems =
    (filledOutQuestionnaires && filledOutQuestionnaires.length > 0) ||
    hasBmsSampleRedeemed;

  return (
    <Flex flex="1" direction="column" gap="8px">
      <Text fw="600" size="21px" lh="24px">
        {t('Wrapper.ClosedQuestionnaires')}
      </Text>

      <Text size="16px" lh="24px" c="#4A4A48">
        {t('Wrapper.ClosedQuestionnairesSubtitle')}
      </Text>
      <Flex gap="10px">
        <Text size="21px" lh="120%" fw="600">
          {store.collectedAmount} CHF
        </Text>
        <Text>{t('Wrapper.VouchersCollected')}</Text>
      </Flex>
      <Divider c="#D0CDB1" />
      <Flex gap="8px" align="center">
        <Flex
          bg="#F7F6F1"
          w="28px"
          h="28px"
          style={{ borderRadius: '50%' }}
          justify="center"
          align="center"
        >
          <MyIcon name="donateHand" />
        </Flex>
        <Text c="#4A4A48" size="16px" fw="400" lh="24px">
          {t('Wrapper.VouchersDonated', {
            amount: store.donatedAmount,
          })}
        </Text>
      </Flex>
      <Flex gap="8px" align="center">
        <Flex
          bg="#F7F6F1"
          w="28px"
          h="28px"
          style={{ borderRadius: '50%' }}
          justify="center"
          align="center"
        >
          <MyIcon name="pig" />
        </Flex>
        <Text c="#4A4A48" size="16px" fw="400" lh="24px">
          {t('Wrapper.VouchersUsed', {
            amount: store.redeemedAmount,
            total: store.redeemableAmount,
          })}
        </Text>
      </Flex>
      <Space h="10px" />

      <Skeleton visible={store.loading}>
        {!hasItems ? (
          <EmptyPlaceholder forOpen={false} />
        ) : (
          <Flex gap="10px" direction="column">
            {hasBmsSampleRedeemed && <BmsSampleVoucherItem />}
            {filledOutQuestionnaires?.map((item) => (
              <QuestionnaireItem key={item.surveyLinkId} questionnaire={item} />
            ))}
          </Flex>
        )}
      </Skeleton>
    </Flex>
  );
});
